import { Tag as TagAtom } from 'module/ui/components/atoms/tag';
import classNames from 'classnames';
import { FC } from 'react';
import styled, { css } from 'styled-components';
import type { Color } from 'module/ui/components/styles/colors';
import type { FieldOptionBase } from 'module/api/field/types';

interface Props {
  option: FieldOptionBase;
  dataCy?: string;
  showPosition?: boolean;
}

const Tag = styled(TagAtom)<{ $showPosition: boolean }>`
  ${({ $showPosition }) =>
    $showPosition
      ? css`
          padding-left: calc(var(--spacing-02) - 1px);
        `
      : null};
`;

const Circle = styled.span<{ color: Color }>`
  --tag-border-color: var(--tag-surface-color);
  height: var(--height-sm);
  width: var(--height-sm);
  border-radius: 50%;
  ${({ color }) => css`
    --tag-surface-color: var(--${color}-20);
    --tag-color: var(--ozone-${color});
  `};
  &.disabled,
  &[disabled] {
    --tag-surface-color: var(--gray-10);
    --tag-color: var(--gray-30);
  }
  border: 1px solid var(--tag-border-color);
  background: var(--tag-surface-color);
  color: var(--tag-color);

  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: var(--spacing-03);
`;

export const SelectFieldOption: FC<React.PropsWithChildren<Props>> = ({
  option: { color, label, active = true, position },
  dataCy,
  showPosition = false,
}) =>
  color == null ? (
    <>{label}</>
  ) : (
    <Tag
      $showPosition={showPosition}
      color={color}
      data-cy={dataCy}
      className={classNames({
        disabled: !active,
      })}
    >
      {showPosition ? (
        <Circle
          color={color}
          data-cy={`${dataCy ?? 'tag-option'}.position`}
          className={classNames({
            disabled: !active,
          })}
        >
          {position}
        </Circle>
      ) : null}
      {label}
    </Tag>
  );
